export default __webpack_public_path__ + "static/media/gmail_icon.8d55216f.png";